function showUp(dom){
    gsap.from(dom, {
        y: '2rem', opacity: 0, ease: 'none', duration: 0.5,
        scrollTrigger: {
            trigger: dom,
            start: 'top bottom-=20%',
            end: '+=0',
            //toggleActions: 'play none none reverse',
        }
    })
}

function onViewLoad(className) {
    const elements = $(className).get();
    
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                const video = entry.target
                video.src = video.dataset.src
                video.load()
                observer.unobserve(video);
            }
        });
    }, { threshold:0,rootMargin: '500px', });
    
    elements.forEach(el => observer.observe(el));
}

const preloadImages = () => {
    for(let i=1;i<24;i++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0930/5397/6894/files/glovian_box5_${i}.avif?v=1783913766`;
    }
    
};
preloadImages()

onViewLoad('.lazy_video')

var wFlag = window.innerWidth > 750

$(()=>{
    setTimeout(() => {
        $('.box1_title').css({transform:'translateY(0)',opacity:1})
    }, 300);

    //box2
    ScrollTrigger.create({
        trigger:'.box2_item',
        start:'top bottom-=30%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box2_item div',{y:'2rem',opacity:0,stagger:0.2})
    })

    //box3
    ScrollTrigger.create({
        trigger: '.box3',
        start: 'top top+=10%',
        end:'+=0%',
        toggleActions: 'play none none reverse',
        animation: gsap.from(".box3_btn", {
            y: wFlag?"20rem":"10rem",
            rotation: -10,
            opacity: 0,
            duration: 0.8,
            ease: "back.out(2)"
        })
    });

    ScrollTrigger.create({
        trigger:'.box3',
        start:wFlag?'top+=20% top+=4%':'top+=22% top',
        end:'+=80%',
        scrub:1,
        animation:gsap.timeline()
            .from('.box3_btn',{clipPath:wFlag?'inset(43% 32% 43% 32% round 4rem)':'inset(35% 12% 47% 12% round 1rem)'})
            .to('.box3_btn div',{opacity:0},'-=80%')
            .from('.box3_bg',{opacity:0})
            .from('.box3_title',{opacity:0,y:'1rem'})
            .to({},{duration:0.2})
    })

    ScrollTrigger.create({
        trigger:'.box3',
        start:wFlag?'top top+=4%':'top+=2% top',
        end:'+=120%',
        pin:true,
    })

    //box4
    showUp('.box4_title')
    ScrollTrigger.create({
        trigger:'.box4',
        // +=8%
        start:wFlag?'top top+=4%':'top top',
        end:'+=100%',
        pin:true,
        scrub:1,
        animation:gsap.timeline()
            .to({},{duration:0.2})
            .to('.box4_flag,.box4_item,.box4_text',{opacity:0})
            .from('.box4_img',{clipPath:wFlag?'inset(28% 23% 22% 23% round 1.5rem)':'inset(28% 5% 20% 5% round 1rem)',filter:'brightness(0.2)'})
            .from('.box4_img img',{y:wFlag?'9%':'0',scale:wFlag?0.65:1},'<')
            .from('.box4_icon',{opacity:0})
            .to({},{duration:0.2})
    })

    //box5
    var $content = $(".marquee-content");
    var html = $content.html();

    // 复制一份，实现无缝滚动
    $content.append(html);

    var width = $content.children().eq(0).outerWidth(true);

    var left = 0;

    function move(){
        left++;
    
        if(left >= 0){
            left = -width;
        }
    
        $content.css({
            transform:`translateX(${left}px)`
        });
    
        requestAnimationFrame(move);
    }

    if(wFlag){
        move();
    }
    showUp('.box5_title')

    ScrollTrigger.create({
        trigger:'.box5',
        start:wFlag?'top top':'top top+=4%',
        end:'+=100%',
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 22);
            $('.box5_img').attr('src', `https://cdn.shopify.com/s/files/1/0930/5397/6894/files/glovian_box5_${index+1}.avif`)
        }
    })
    ScrollTrigger.create({
        trigger:'.box5',
        start:wFlag?'top top':'top top+=4%',
        end:'+=120%',
        pin:true,
    })

    //box6
    showUp('.box6_title')
    ScrollTrigger.create({
        trigger:'.box6',
        start:wFlag?'top top':'top top+=4%',
        end:'+=80%',
        pin:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 10);
            if(index>3){
                $('.box6_icon1').removeClass('box6Active')
                $('.box6_icon2').addClass('box6Active')
                $('.box6_img img:last-child').addClass('opacity1')
            }else{
                $('.box6_icon2').removeClass('box6Active')
                $('.box6_icon1').addClass('box6Active')
                $('.box6_img img:last-child').removeClass('opacity1')
            }
        }
    })

    //box8
    $('.box8_play').click(function(){
        $('.box8_video').addClass('box8Active')
        $('.box8_video video')[0].play()
    })
    $('.box8_close').click(function(){
        $('.box8_video').removeClass('box8Active')
        $('.box8_video video')[0].pause()
    })
    showUp('.box8_title')
    if(!wFlag){
        ScrollTrigger.create({
            trigger:'.box8',
            start:'top top+=4%',
            end:'+=50%',
            pin:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 10);
                $('.box8_items .box8_item:last-child').toggleClass('box8Active',index>4)
            }
        })
    }

    //box9
    showUp('.box9_title')
    new Swiper('.box9Swiper', {
        autoplay: {
            reverseDirection: true
        },
        slidesPerView: wFlag?5:2,
        centeredSlides: true,
        loop:true,
        navigation: {
            nextEl: '.box9_right',
            prevEl: '.box9_left',
        },
    })


    //specs
    showUp('.specs_item1 img')

    new Swiper('.box9_1Swiper', {
        autoplay: {
            delay: wFlag?2000:1500,
            disableOnInteraction: false,
            reverseDirection: true
        },
        slideToClickedSlide: true,
        centeredSlides: true,
        slidesPerView:wFlag?6:1.5,
        loop:true
    })
})